import * as React from 'react';
const SvgIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" viewBox="0 -960 960 960">
    <path fill={props.fill || '#1D252D'} d="M250-140v-60h460v60z"></path>
  </svg>;
export default React.memo(SvgIcon);